export const collatorArgNames = ['pagination', 'sorting', 'clearCache'];

/**
 * Create a cache key based on `args` props
 *
 * We asume that every prop is a string
 * TODO: Support different prop types (Object,Array?)
 *
 * @param {Object} args Object with args to create a key from
 *
 * @returns {String} Cache key
 */
export function createCacheKeyFromArgs(args) {
	const argValues = [];
	for (const prop in args) {
		argValues.push(args[prop]);
	}

	return argValues.join('-');
}

/**
 * Remove collator args (`collatorArgNames`) from object
 *
 * @param {Object} args Object containin collator args
 *
 * @returns {Object} Args without collator params
 */
export function extractFnArgs(args) {
	const fnArgs = Object.assign({}, args);

	for (const prop in args) {
		if (collatorArgNames.includes(prop)) {
			delete fnArgs[prop];
		}
	}

	return fnArgs;
}



// WEBPACK FOOTER //
// ./src/state/helpers/collated/utils.js